/**
 * [切换环境]
 * @Date 2019/08/01
 * @Author Louis
 * @Param {[String]} 环境
 */
// let data = getParamConfig('dev');						// 开发环境
// let data = getParamConfig('test');					// 测试环境
let data = getParamConfig('prod');					// 生产环境

let config = {
	baseUrl: data.baseUrl,
	domainName: data.domainName,
	sip: data.sip,
	environment: data.environment
}

function getParamConfig(env){
	let data = {
		baseUrl: '',
		domainName: '',
		sip: '',
		environment: ''
	};
	switch (env) {
		case 'dev':
			data.baseUrl = "http://127.0.0.1:8080/dev";
			data.domainName = "http://127.0.0.1:8080";
			data.sip = 'https://testnet.iob.community';
			data.environment = 'Development';
			break;
		case 'test':
			data.baseUrl = "https://api-testnet.iobots.pro/iobots";
			data.domainName = "https://testboard.iobots.pro";
			data.sip = 'https://testnet.iob.community';
			data.environment = 'Test';
			break;
		case 'prod':
			data.baseUrl = "https://api.iobots.pro/iobots";
			data.domainName = "https://dashboard.iobots.pro";
			data.sip = "https://iob.community";
			data.environment = '';
			break;
		default:
			data.baseUrl = "http://127.0.0.1:3000";
			data.domainName = "http://127.0.0.1:8080";
			data.sip = 'https://testnet.iob.community';
			data.environment = 'Development';
			break;
	}
	return data;
}

export default config